import { render, staticRenderFns } from "./ClientAdd.vue?vue&type=template&id=f36c9188"
import script from "./ClientAdd.vue?vue&type=script&lang=js"
export * from "./ClientAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports